module.exports = __webpack_public_path__ + "static/media/travelling.a5f78d7f.jpg";